<div class="main-container">
  <router-outlet></router-outlet>
</div>
  <div class="chat-global-container" id="chatGlobalContainer" *ngIf="chatEnabled">
    <button tabindex="-1" mat-fab #tooltip="matTooltip" class="chat-bg-color"
      [matTooltip]="chatSessionActive ? 'Close Chat' : 'Open Chat'" [matTooltipPosition]="'left'" id="chatToggleButton"
      [matTooltipClass]="['global-icon-tooltip']" (click)="onToggleChat()">
      <i *ngIf="!chatSessionActive" class="fas fa-comment-alt" aria-hidden="true" id="chatIconOpen"></i>
      <i *ngIf="chatSessionActive" class="fas fa-times" aria-hidden="true" id="chatIconClose"></i>
    </button>
  </div>